import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useExportIntervalDataReport } from '../../hooks/useExportIntervalDataReport'
import { EmailExportModal } from '@/components/organisms/EmailExportModal/EmailExportModal'
import { MenuItem } from '@/components/common/MenuItem/MenuItem'

export type ExportIntervalDataReportProps = {
    reportId: string
    onClick?: () => void
    onExportingChange?: (isExporting: boolean) => void
}

export const ExportIntervalDataReport: React.FC<
    ExportIntervalDataReportProps
> = ({ reportId, onClick, onExportingChange }) => {
    const { t } = useTranslation('translations')

    const { exportIntervalDataReport, emailExportModalProps, isExporting } =
        useExportIntervalDataReport(reportId)

    useEffect(() => {
        onExportingChange?.(isExporting)
    }, [isExporting, onExportingChange])

    return (
        <>
            <EmailExportModal {...emailExportModalProps} />
            <MenuItem
                path="/"
                variant="ghost"
                label={t('common.export_report_dropdown.options.xls')}
                render={({ renderContents }) => (
                    <button
                        className="group w-full outline-none"
                        onClick={() => {
                            onClick?.()
                            exportIntervalDataReport()
                        }}
                        data-testid="export-interval-data-excel-button"
                    >
                        {renderContents()}
                    </button>
                )}
            />
        </>
    )
}
